export async function getOwnerIvideon(id: string) {
  const url = `/internal-api/ivideon/dealers?dealerSearch[ids][]=${id}&ivideonAuthorized=true&count=25&page=0`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Ошибка: ", error);
  }
}
